var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"u-mt-md"},[_c('AppTitle',{staticClass:"u-mb-0",attrs:{"title":_vm.$t('mantra')}})],1),_c('section',{staticClass:"u-mt-md"},[_c('Explore')],1),_c('div',{staticClass:"u-mb-md"})])}
var staticRenderFns = []

export { render, staticRenderFns }